import React, {useState, useEffect, useRef} from 'react';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import SelectInfinite from '../../components/FormFields/SelectInfinite';
import InputText from '../../components/FormFields/InputText';
import TextArea from '../../components/FormFields/Textarea';
import * as yup from 'yup';
import {getLanguage, t} from 'react-switch-lang';
import {Col, Row} from 'react-bootstrap';
import {
  getPotentionalRisks,
  editLitigation,
  getRiskFile,
  GetPotentionalRisk, getSubjectStatus,
} from '../../services/litigationService';
import SelectList from '../../components/select/SelectList';
import './Litigation.scss';
import {useUserContext} from '../../contexts/UserContext';
import Toast from '../../components/toast/Toast';
import InputDate from '../../components/FormFields/inputDate/InputDate';
import 'antd/dist/antd.css';
import {useDepartmentContext} from '../../contexts/DepartmentContext';
import {defaultMinValueZero} from '../../utils/const';
import allowedFileTypes from '../../utils/allowedFileTypes';
import PreventTransitionPrompt from '../../components/preventTransitionprompt/PreventTransition';
import {format} from 'date-fns';
import {
  formatNumberInput,
  parseFormattedNumber,
  maxDecimalNumber, formatNumberForDisplay,
  onDecimalNumberInputChange, testIsGreaterThanMin,
  testValidNumber, handlePasteAndValidate, formatNumber,
} from '../../utils/helpers';
import FileUploadSection from "../../components/FileUploadSection/FileUploadSection";
import {getDepartment} from '../../services/IncurredEvent/incurredEventApi';
import LossModal from '../IncurredRisk/components/modals/LossModal';
import editImage from '../IncurredRisk/components/img/edit.svg';
import deleteImage from '../IncurredRisk/components/img/delete.svg';

const Litigation = ({defaultData}) => {
  const lang = getLanguage();
  const user = useUserContext();
  const userDepartment = useDepartmentContext();

  const bankLegitimationSelected = () => {
    if (defaultData.bankLegitimation === 'PLAINTIFF') {
      return bankLegitimation[1];
    } else {
      return bankLegitimation[0];
    }
  };
  const [disabledRisk, setDisabledRisk] = useState(true);
  // const [disableSubprocess, setDisableSubPorcess] = useState(false);
  const [potentionalRisks, setPotentionalRisks] = useState([]);
  // const [subCauses, setSubCauses] = useState([]);
  const [userResponsibleLogin,setUserResponsibleLogin] = useState();
  const [disableSubCategory, setDisableSubCategory] = useState(false);
  const [subjectStatusOptions, setSubjectStatusOptions] = useState([]);

  // const [disableSubCause, setDisableSubCause] = useState(false);
  const [litigation, setLitigation] = useState({
    id: defaultData.id,
    potentialRisk: {
      value: defaultData.risk.potentialRiskId,
      label:
        lang === 'eng'
          ? defaultData.risk.potentialRiskTitle
          : defaultData.risk.potentialRiskTitle,
    },
    title: defaultData.risk.title,
    description: defaultData.risk.description,
    typeGainLoss: {
      value: defaultData.risk.typeGainLossId,
      label:
        lang === 'eng'
          ? defaultData.risk.typeGainLossNameEn
          : defaultData.risk.typeGainLossName,
    },
    // riskCause: {
    //   value: defaultData.risk.riskCauseId,
    //   label:
    //     lang === 'eng'
    //       ? defaultData.risk.riskCauseNameEn
    //       : defaultData.risk.riskCauseName,
    // },
    // riskSubCause: {
    //   value: defaultData.risk.riskSubCauseId,
    //   label:
    //     lang === 'eng'
    //       ? defaultData.risk.riskSubCauseNameEn
    //       : defaultData.risk.riskSubCauseName,
    // },
    // process: {
    //   value: defaultData.risk.processId,
    //   label:
    //     lang === 'eng'
    //       ? defaultData.risk.processNameEn
    //       : defaultData.risk.processName,
    // },
    // subprocess: {
    //   value: defaultData.risk.subprocessId,
    //   label:
    //     lang === 'eng'
    //       ? defaultData.risk.subprocessNameEn
    //       : defaultData.risk.subprocessName,
    // },
    category: {
      value: defaultData.courtCategoryRiskId,
      label:
        lang === 'eng'
          ? defaultData.courtCategoryRiskNameEn
          : defaultData.courtCategoryRiskName,
    },
    subcategory: {
      value: defaultData.courtSubcategoryRiskId,
      label:
        lang === 'eng'
          ? defaultData.courtSubcategoryRiskNameEn
          : defaultData.courtSubcategoryRiskName,
    },
    // businessLine: {
    //   value: defaultData.risk.businessLineId,
    //   label:
    //     lang === 'eng'
    //       ? defaultData.risk.businessLineNameEn
    //       : defaultData.risk.businessLineName,
    // },
    departmentStakeholder: {
      value: defaultData.risk.departmentStakeholderId,
      label:
        lang === 'eng'
          ? defaultData.risk.departmentStakeholderNameEn
          : defaultData.risk.departmentStakeholderName,
    },
    estimatedGrossLost: parseFormattedNumber(defaultData.risk.estimatedGrossLost),
    comment: defaultData.risk.comment,
    typeCourtDispute: defaultData.typeCourtDispute,
    bankLegitimation: bankLegitimationSelected,
    commissioner: defaultData.commissioner,
    startingDateDispute: defaultData.startingDateDispute,
    subjectDispute: defaultData.subjectDispute,
    jurisdiction: defaultData.jurisdiction,
    valueCourtDispute: defaultData.valueCourtDispute,
    provisionAmount: parseFormattedNumber(defaultData.provisionAmount),
    feeReservation: defaultData.feeReservation,
    lossDispute: defaultData.lossDispute,
    subjectStatus: {
      value: defaultData?.subjectStatus,
      label:
        lang === 'eng'
          ? defaultData?.subjectStatus
          : defaultData?.subjectStatus,
    },
    courtId: defaultData.id,
    riskId: defaultData.risk.id,
    riskStatusId: defaultData.risk.riskStatusId,
    files: defaultData.risk.files,
    riskDateCreated: defaultData.risk.dateCreated,
    riskStatus:
      lang === 'eng'
        ? defaultData.risk.riskStatusNameEn
        : defaultData.risk.riskStatusName,
    departmentSource:
      lang === 'eng'
        ? defaultData.risk.departmentSourceNameEn
        : defaultData.risk.departmentSourceName,
    userInChargeRisk:
      defaultData.risk.userInChargeFirstName +
      ' ' +
      defaultData.risk.userInChargeLastName,
    responsibleUserRisk:
      defaultData.risk.userResponsibleFirstName +
      ' ' +
      defaultData.risk.userResponsibleLastName,
    riskEstimationId: defaultData.risk.riskEstimationId,
    courtDisputeOutcomeAssessment: defaultData?.courtDisputeOutcomeAssessment
  });
  const [files, setFiles] = useState([]);
  const [deleteFiles, setDeleteFiles] = useState([]);
  const [riskEstimation, setRiskEstimation] = useState(null);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  // const prevProcessIdRef = useRef(null);
  const prevCategoryIdRef = useRef(null);
  // const prevCauseIdRef = useRef(null);
  const [lossModalOpen,setLossModalOpen] = useState(false);
  const [isEdit,setIsEdit] = useState(false);
  const [renderAfter, setRenderAfter] = useState(0);

  const [lossData, setLossData] = useState(
    defaultData?.riskExpenses?.length > 0
      ? defaultData.riskExpenses.map((item) => ({
        ...item,
        lossReason: {
          value: item.lossReason.id,
          label: item.lossReason.name,
        }
      }))
      : []
  );
  const [currentID,setCurrentID] = useState();
  const bankLegitimation = [
    {value: 'RESPONDENT', label: lang === 'eng' ? 'Respondent' : 'Tuženi'},
    {value: 'PLAINTIFF', label: lang === 'eng' ? 'Plaintiff' : 'Tužilac'},
  ];

  const [schema, setSchema] = useState(
    yup.object().shape({
      title: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(100, t('message.max', {max: 100})),
      description: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(2048, t('message.max', {max: 2048})),
      // riskCauseId: yup.object().nullable().required(t('message.fieldRequired')),
      departmentStakeholderId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      courtCategory: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      subCategory: yup.object().nullable().required(t('message.fieldRequired')),
      estimatedGrossLost: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
          .test('is-greater-than-min', t('message.minValue', {min: defaultMinValueZero}), (value) => {
            return testIsGreaterThanMin(value,defaultMinValueZero);
          })
          .test('is-valid-number', t('message.mustBeNumber'), (value) => {
            return testValidNumber(value,true);
          }).test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
            return maxDecimalNumber(value);
          })
        .max(20, t('message.max', {max: 20})),
      // methodologyId: yup
      //   .object()
      //   .nullable()
      //   .required(t('message.fieldRequired')),
      comment: yup
        .string()
        .trim()
        .max(2048, t('message.max', {max: 2048})),
      typeCourtDispute: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(255, t('message.max', {max: 255})),
      bankLegitimation: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      proxyInfo: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(255, t('message.max', {max: 255})),
      litigationDate: yup
        .string()
        .nullable()
        .required(t('message.fieldRequired')),
      disputeSubject: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(255, t('message.max', {max: 255})),
      jurisdiction: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(255, t('message.max', {max: 255})),
      litigationValue: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
          .test('is-greater-than-min', t('message.minValue', {min: defaultMinValueZero}), (value) => {
            return testIsGreaterThanMin(value,defaultMinValueZero);
          })
          .test('is-valid-number', t('message.mustBeNumber'), (value) => {
            return testValidNumber(value,true);
          }).test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
            return maxDecimalNumber(value);
          })
        .max(20, t('message.max', {max: 20})),
      provisionAmount: yup
        .string()
        .trim()
        // .required(t('message.fieldRequired'))
        //   .test('is-greater-than-min', t('message.minValue', {min: defaultMinValueZero}), (value) => {
        //     return testIsGreaterThanMin(value,defaultMinValueZero);
        //   })
        //   .test('is-valid-number', t('message.mustBeNumber'), (value) => {
        //     return testValidNumber(value,true);
        //   })
      .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
            return maxDecimalNumber(value);
          })
        .max(20, t('message.max', {max: 20})),
      reimbursementProvision: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
          .test('is-greater-than-min', t('message.minValue', {min: defaultMinValueZero}), (value) => {
            return testIsGreaterThanMin(value,defaultMinValueZero);
          })
          .test('is-valid-number', t('message.mustBeNumber'), (value) => {
            return testValidNumber(value,true);
          }).test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
            return maxDecimalNumber(value);
          })
        .max(20, t('message.max', {max: 20})),
      litigationLoss: yup
        .string()
        .trim()
        // .required(t('message.fieldRequired'))
        //   .test('is-greater-than-min', t('message.minValue', {min: defaultMinValueZero}), (value) => {
        //     return testIsGreaterThanMin(value,defaultMinValueZero);
        //   })
        //   .test('is-valid-number', t('message.mustBeNumber'), (value) => {
        //     return testValidNumber(value,true);
        //   })
        .test('max-two-decimals', t('message.maxTwoDecimals'), (value) => {
            return maxDecimalNumber(value);
          })
        .max(20, t('message.max', {max: 20})),
      subjectStatus: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      // process: yup.string().nullable().required(t('message.fieldRequired')),
      // subprocessId: yup
      //   .string()
      //   .nullable()
      //   .required(t('message.fieldRequired')),
      // riskSubCause: yup
      //   .object()
      //   .nullable()
      //   .required(t('message.fieldRequired')),
      lossChargedInsurance: yup.string().when('netLoss', {
        is: (value) => parseFormattedNumber(value) > 0,
        then: yup
          .string()
          .required(t('message.fieldRequired'))
          .test(
            'is-greater-than-min',
            t('message.minValue', {min: defaultMinValueZero}),
            (value) => testIsGreaterThanMin(value, defaultMinValueZero)
          )
          .test(
            'is-valid-number',
            t('message.mustBeNumber'),
            (value) => testValidNumber(value)
          )
          .test(
            'max-two-decimals',
            t('message.maxTwoDecimals'),
            (value) => maxDecimalNumber(value)
          ),
        otherwise: yup.string().nullable(),
      }),
      lossChargedOther: yup.string().when('netLoss', {
        is: (value) => parseFormattedNumber(value) > 0,
        then: yup
      .string()
      .required(t('message.fieldRequired'))
      .test(
        'is-greater-than-min',
        t('message.minValue', {min: defaultMinValueZero}),
        (value) => testIsGreaterThanMin(value, defaultMinValueZero)
      )
      .test(
        'is-valid-number',
        t('message.mustBeNumber'),
        (value) => testValidNumber(value)
      )
      .test(
        'max-two-decimals',
        t('message.maxTwoDecimals'),
        (value) => maxDecimalNumber(value)
      ),
    otherwise: yup.string().nullable(),
  }),
      courtDisputeOutcomeAssessment: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(2000, t('message.max', {max: 2000})),
    })
  );

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit, watch, trigger,setValue} = methods;
  // const watchProcess = watch('process');
  const watchCategory = watch('courtCategory');
  // const watchRiskCause = watch('riskCauseId');
  // const watchSubprocess = watch('subprocessId');
  const watchPotentialRisk = watch('riskType');
  const watchDepartmentSourceId = watch('departmentStakeholderId');
  const fetchPotentionalRisks = async () => {
    try {
      const {data} = await getPotentionalRisks();
      return data;
    } catch (e) {}
  };

  useEffect(() => {
    window.location.pathname.includes('edit')
      ? setDisabledRisk(false)
      : setDisabledRisk(true);
  }, []);
  // useEffect(() => {
  //   const newCauseId = watchRiskCause?.value ?? null;
  //   const prevCauseId = prevCauseIdRef.current;
  //   setRenderAfter(renderAfter + 1);
  //   if (watchRiskCause && !window.location.pathname.includes('edit')) {
  //     setDisableSubCause(true)
  //   }
  //   if (watchRiskCause && window.location.pathname.includes('edit')) {
  //     if (renderAfter >= 3) {
  //       setDisableSubCause(false)
  //       setValue('riskSubCause', '', {
  //         shouldValidate: false,
  //         shouldDirty: false,
  //       });
  //     }
  //   }
  //   if (watchRiskCause === null) {
  //     setDisableSubCause(true);
  //     setValue('riskSubCause', '', {
  //       shouldValidate: false,
  //       shouldDirty: false,
  //     });
  //   }
  //   if (watchRiskCause !== null && prevCauseId !== null && prevCauseId !== newCauseId) {
  //     setValue('riskSubCause', '', {shouldValidate: false, shouldDirty: true});
  //     setDisableSubCause(false);
  //   }
  //   prevCauseIdRef.current = newCauseId;
  // }, [watchRiskCause]);
  //
  // useEffect(() => {
  //   const newProcessId = watchProcess?.value ?? null;
  //   const prevProcessId = prevProcessIdRef.current;
  //   setRenderAfter(renderAfter + 1);
  //   if (watchProcess && !window.location.pathname.includes('edit')) {
  //     setDisableSubPorcess(true);
  //   }
  //   else if (watchProcess && window.location.pathname.includes('edit')) {
  //     if (renderAfter >= 3) {
  //       setDisableSubPorcess(false);
  //       setValue('subprocessId', '', {
  //         shouldValidate: false,
  //         shouldDirty: false,
  //       });
  //     }
  //   }
  //   else if (watchProcess === null) {
  //     setDisableSubPorcess(true);
  //     setValue('subprocessId', '', {
  //       shouldValidate: false,
  //       shouldDirty: false,
  //     });
  //   }
  //   if (watchProcess !== null && prevProcessId !== null && prevProcessId !== newProcessId) {
  //     setValue('subprocessId', '', {shouldValidate: false, shouldDirty: true});
  //     setDisableSubPorcess(false);
  //   }
  //   prevProcessIdRef.current = newProcessId;
  // }, [watchProcess]);
  useEffect(() => {
    const newCategoryId = watchCategory?.value ?? null;
    const prevCategoryId = prevCategoryIdRef.current;
    setRenderAfter(renderAfter + 1);
    if (watchCategory && !window.location.pathname.includes('edit')) {
      setDisableSubCategory(true)
    }
    if (watchCategory && window.location.pathname.includes('edit')) {
      if (renderAfter >= 3) {
        setDisableSubCategory(false)
        setValue('subCategory', '', {
          shouldValidate: false,
          shouldDirty: false,
        });
      }
    }
    if (watchCategory === null) {
      setDisableSubCategory(true);
      setValue('subCategory', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
    if (watchCategory !== null && prevCategoryId !== null && prevCategoryId !== newCategoryId) {
      setValue('subCategory', '', {shouldValidate: false, shouldDirty: true});
      setDisableSubCategory(false);
    }
    prevCategoryIdRef.current = newCategoryId;
  }, [watchCategory]);

  useEffect(() => {
    fetchPotentionalRisks().then((r) => {
      let options = [];
      r.forEach((item) => {
        options.push({
          value: item.id,
          label: item.title,
        });
      });
      setPotentionalRisks(options);
    });
    let departmentsArray = [];
    userDepartment.forEach((item) => {
      departmentsArray.push({
        id: item.id,
        name: lang === 'eng' ? item.nameEn : item.name,
      });
    });
  }, []);

  useEffect(() => {
    if (watchPotentialRisk) {
      const fetchPotentialRiskData = async () => {
        try {
          const {data} = await GetPotentionalRisk(watchPotentialRisk?.value);
          setRiskEstimation(data[0].riskEstimationId);
        } catch (e) {
          // console.log(e);
        }
      };
      fetchPotentialRiskData();
    }
  }, [watchPotentialRisk]);

  useEffect(() => {
    let departmentsArray = [];
    userDepartment.forEach((item) => {
      departmentsArray.push({
        value: item.id,
        label: lang === 'eng' ? item.nameEn : item.name,
      });
      setDepartmentOptions(departmentsArray);
    });
  }, []);

  const handleCancel = (e) => {
    e.preventDefault();
    window.location = `/court-risk/${defaultData.id}`;
  };

  const submitForm = async (data) => {
    const files = document.getElementById('upload').files;
    const date =
      format(new Date(data.litigationDate), 'yyyy-MM-dd') +
      'T' +
      format(new Date(data.litigationDate), 'hh:mm:ss');
    const payload = {
      id: parseInt(litigation.courtId),
      courtSubcategoryRiskId: data.subCategory.value,
      typeCourtDispute: data.typeCourtDispute,
      bankLegitimation: data.bankLegitimation.value,
      commissioner: data.proxyInfo,
      startingDateDispute: date,
      subjectDispute: data.disputeSubject,
      jurisdiction: data.jurisdiction,
      valueCourtDispute: parseFormattedNumber(data.litigationValue),
      provisionAmount: parseFormattedNumber(data.provisionAmount),
      feeReservation: parseFormattedNumber(data.reimbursementProvision),
      lossDispute: parseFormattedNumber(data.litigationLoss),
      subjectStatus: data.subjectStatus ? data.subjectStatus.value : null,
      dateCreated: defaultData.dateCreated,
      grossLoss: parseFormattedNumber(data?.grossLoss),
      lossChargedInsurance: parseFormattedNumber(data?.lossChargedInsurance),
      lossChargedOther: parseFormattedNumber(data?.lossChargedOther),
      netLoss: parseFormattedNumber(data?.netLossNumber),
      courtDisputeOutcomeAssessment: data?.courtDisputeOutcomeAssessment,
      risk: {
        id: parseInt(litigation.riskId),
        riskStatusId: litigation.riskStatusId,
        departmentSourceId: userDepartment[0].id,
        active: true,
        riskCategoryId: 3,
        applicationDate: new Date(),
        userInChargeId: user.id,
        userInChargeLogin: user.login,
        userResponsibleId: data.userResponsibleId.value,
        userResponsibleLogin: userResponsibleLogin,
        potentialRiskId: data.riskType ? data.riskType.value : null,
        title: data.title,
        description: data.description,
        typeGainLossId: data.typeGainLossId ? data.typeGainLossId.value : null,
        // methodologyId: data.methodologyId.value,
        // riskCauseId: data.riskCauseId.value,
        // riskSubCauseId: data.riskSubCause.value,
        departmentStakeholderId: data.departmentStakeholderId.value,
        courtCategoryId: data.courtCategory.value,
        // processId: watchProcess['value'],
        // subprocessId: watchSubprocess['value'],
        estimatedGrossLost: parseFormattedNumber(data.estimatedGrossLost),
        comment: data.comment ? data.comment : '',
        // businessLineId: data.businessLineId ? data.businessLineId.value : null,
        userCreatedId: user.id,
        deleteFiles: deleteFiles,
        riskEstimationId: riskEstimation,
        dateCreated: defaultData.risk.dateCreated
      },
      riskExpenses: lossData.length > 0 ? lossData.map((item) => (
        {
          id:item.id,
          lossReason: {
            id:item.lossReason.value,
            name: item.lossReason.label
          },
          netLoss: parseFormattedNumber(item.netLoss),
          lossDate: item.lossDate,
          description: item.description
        }
      )) : [],
    };

    try {
      const response = await editLitigation(payload, files);
      if (response.status === 200) {
        await Toast.fire({
          title: t('litigation.messages.editSuccess'),
          icon: 'success',
        });
        window.location = `/court-risk/${parseInt(litigation.id)}`;
      }
    } catch (err) {
      Toast.fire({
        title: t('litigation.messages.editError'),
        icon: 'error',
      });
    }
  };

    const clearFetchedFile = (id) => {
        let children = litigation.files.filter((file) => file.id !== id);
        setLitigation({...litigation, ['files']: children});
        setDeleteFiles([...deleteFiles, id]);
    };

    const onChangeReimbursementProvision = (e) => {
        let result = '';
        let valueNoText = e.target.value.replace(/[^0-9.]/, '');
        let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
        if (valueDouble !== undefined && valueDouble !== null) {
            result = valueDouble[1];
        }
        setValue('reimbursementProvision', result);
    };

  const onChangeLitigationLoss = (e) => {
    let result = '';
    let valueNoText = e.target.value.replace(/[^0-9.]/, '');
    let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
    if (valueDouble !== undefined && valueDouble !== null) {
      result = valueDouble[1];
    }
    setValue('litigationLoss', result);
  };

  const onChangeProvisionAmount = (e) => {
    let result = '';
    let valueNoText = e.target.value.replace(/[^0-9.]/, '');
    let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
    if (valueDouble !== undefined && valueDouble !== null) {
      result = valueDouble[1];
    }
    setValue('provisionAmount', result);
  };

  const onChangeLitigationValue = (e) => {
    let result = '';
    let valueNoText = e.target.value.replace(/[^0-9.]/, '');
    let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
    if (valueDouble !== undefined && valueDouble !== null) {
      result = valueDouble[1];
    }
    setValue('litigationValue', result);
  };
  useEffect(() => {
    const fetchSubjectStatuses = async () => {
      try {
        const { data } = await getSubjectStatus();
        setSubjectStatusOptions(
          data.map((item) => ({
            value: item.id,
            label: item.name,
          }))
        );
      } catch (e) {}
    };

    fetchSubjectStatuses();
  }, []);
  useEffect(() => {
    if (watchDepartmentSourceId) {
      const depratmentObject = async () => {
        try {
          const {data} = await getDepartment(watchDepartmentSourceId.value);
          setUserResponsibleLogin(data[0]?.userResponsibleLogin)
          setValue('userResponsibleId', {
            value: data[0].userResponsibleId,
            label:
              data[0].userResponsibleFirstName +
              ' ' +
              data[0].userResponsibleLastName,
          });
        } catch {}
      };
      depratmentObject();
    }
  }, [watchDepartmentSourceId]);

  const deleteConto = (id) => {
    setLossModalOpen(false);
    setLossData((prevLossData) =>
      prevLossData.filter(
        (item) => item.id !== id && item.tempId !== id
      )
    );

    // Toast.fire({
    //   title: t('codebook.successfullyDeletedLoss'),
    //   icon: 'success',
    // });
  };

  useEffect(() => {
    if (watchDepartmentSourceId) {
      const depratmentObject = async () => {
        try {
          const {data} = await getDepartment(watchDepartmentSourceId.value);
          setUserResponsibleLogin(data[0]?.userResponsibleLogin)
          setValue('userResponsibleId', {
            value: data[0].userResponsibleId,
            label:
              data[0].userResponsibleFirstName +
              ' ' +
              data[0].userResponsibleLastName,
          });
        } catch {}
      };
      depratmentObject();
    }
  }, [watchDepartmentSourceId]);

  useEffect(() => {
    const index = lossData.findIndex((loss) => loss.id === currentID);
    lossData.forEach((loss, index) => {
      setValue(`lossData.${index}.account`, loss?.lossReason);
    });
    if (index !== -1) {
      const selectedLoss = lossData[index];
      setValue(`lossData.${index}.account`, selectedLoss?.lossReason);
      setValue(`lossData.${index}.account`, selectedLoss?.lossReason);
    }
  },[lossData])
  const sum = lossData.reduce((acc, item) => {
    const value = parseFormattedNumber(item?.netLoss) || 0;
    return acc + value;
  }, 0);

  const netLossNumberValue = sum -
    parseFormattedNumber(watch('lossChargedInsurance')) -
    parseFormattedNumber(watch('lossChargedOther'))

  const handleChange = (event) => {
    event.target.value = formatNumberInput(event.target.value);
  };
  return (
    <>
      {defaultData !== undefined && (
        <>
          <PreventTransitionPrompt when={!disabledRisk} />
          <div className="form mt-4 w-100">
            <FormProvider {...methods}>
              <form onSubmit={handleSubmit(submitForm)}>
                <Row className="field-group-title">
                  <Col className="col-4 col-xl-2">
                    {t('litigation.mainData')}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.title')}
                    </label>
                    <InputText
                      type="text"
                      name="title"
                      defaultValue={litigation.title}
                      className="form-control input-field"
                      placeholder={t('litigation.placeholder.title')}
                      disabled={disabledRisk}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.description')}
                    </label>
                    <TextArea
                      name="description"
                      defaultValue={litigation.description}
                      className={`form-control text-area `}
                      placeholder={t('litigation.placeholder.description')}
                      disabled={disabledRisk}
                    />
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col className="col-6 col-xl-3">
                <label className="label-litigation">
                  {t('litigation.potentionalRisk')}
                </label>
                <span className="optional register">
                      {t('common.optional')}
                    </span>
                <SelectInfinite
                  api="/risks?riskTypeId.equals=1"
                  name="riskType"
                  placeholder={t('incurred-risk.placeholder.potentionalRisk')}
                  labelKey={'title'}
                  className="select"
                  isDisabled={disabledRisk}
                  isClearable
                  queryKeys={'title.contains'}
                  selected={
                    litigation.potentialRisk !== undefined &&
                    litigation.potentialRisk.value
                      ? litigation.potentialRisk
                      : ''
                  }
                />
                  </Col>
                </Row>
                <Row className="mt-5 field-group-title">
                  <Col className="col-4 col-xl-2">
                    {t('litigation.litigationInfo')}
                  </Col>
                </Row>
                <Row>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.typeCourtDispute')}
                    </label>
                    <InputText
                      type="text"
                      name="typeCourtDispute"
                      defaultValue={litigation.typeCourtDispute}
                      className="form-control input-field"
                      placeholder={t('litigation.placeholder.typeCourtDispute')}
                      disabled={disabledRisk}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label
                      className="label-litigation"
                      htmlFor="bankLegitimation"
                    >
                      {t('litigation.bankLegitimation')}
                    </label>
                    <SelectList
                      name="bankLegitimation"
                      isDisabled={disabledRisk}
                      selected={litigation.bankLegitimation}
                      placeholder={t('litigation.placeholder.bankLegitimation')}
                      options={bankLegitimation}
                      isClearable
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.proxyInfo')}
                    </label>
                    <InputText
                      type="text"
                      name="proxyInfo"
                      defaultValue={litigation.commissioner}
                      className="form-control input-field"
                      placeholder={t('litigation.placeholder.proxyInfo')}
                      disabled={disabledRisk}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3 d-flex flex-column">
                    <label className="label-litigation">
                      {t('litigation.litigationDate')}
                    </label>
                    <InputDate
                      name="litigationDate"
                      defaultValue={new Date(litigation.startingDateDispute)}
                      placeholder={t('litigation.placeholder.litigationDate')}
                      style={{height: '45px!important'}}
                      disabled={disabledRisk}
                      maxDate={new Date()}
                      isClearable={disabledRisk ? false : true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.disputeSubject')}
                    </label>
                    <InputText
                      type="text"
                      name="disputeSubject"
                      defaultValue={litigation.subjectDispute}
                      className="form-control input-field"
                      placeholder={t('litigation.placeholder.disputeSubject')}
                      disabled={disabledRisk}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.jurisdiction')}
                    </label>
                    <InputText
                      type="text"
                      name="jurisdiction"
                      defaultValue={litigation.jurisdiction}
                      className="form-control input-field line-height"
                      placeholder={t('litigation.placeholder.jurisdiction')}
                      disabled={disabledRisk}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.litigationValue')}
                    </label>
                    <InputText
                      type="number"
                      name="litigationValue"
                      defaultValue={litigation.valueCourtDispute}
                      className="form-control input-field"
                      placeholder={t('litigation.placeholder.litigationValue')}
                      disabled={disabledRisk}
                      step=".01"
                      min="0"
                      onChange={onChangeLitigationValue}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.provisionAmount')}
                    </label>
                    <span className="optional register">
                  {t('common.optional')}
                </span>
                    <InputText
                      type="number"
                      name="provisionAmount"
                      defaultValue={litigation.provisionAmount}
                      className="form-control input-field line-height"
                      placeholder={t('litigation.placeholder.provisionAmount')}
                      disabled={disabledRisk}
                      step=".01"
                      min="0"
                      onChange={onChangeProvisionAmount}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.reimbursementProvision')}
                    </label>
                    <InputText
                      type="number"
                      name="reimbursementProvision"
                      defaultValue={litigation.feeReservation}
                      className="form-control input-field line-height"
                      placeholder={t(
                        'litigation.placeholder.reimbursementProvision'
                      )}
                      disabled={disabledRisk}
                      step=".01"
                      min="0"
                      onChange={onChangeReimbursementProvision}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.litigationLoss')}
                    </label>
                    <span className="optional register">
                  {t('common.optional')}
                </span>
                    <InputText
                      type="number"
                      name="litigationLoss"
                      defaultValue={litigation.lossDispute}
                      className="form-control input-field line-height"
                      placeholder={t('litigation.placeholder.litigationLoss')}
                      disabled={disabledRisk}
                      step=".01"
                      min="0"
                      onChange={onChangeLitigationLoss}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.subjectStatus')}
                    </label>
                    <SelectList
                      name="subjectStatus"
                      selected={
                        litigation.subjectStatus !== undefined &&
                        litigation.subjectStatus.value
                          ? litigation.subjectStatus
                          : ''
                      }
                      options={subjectStatusOptions}
                      className="select"
                      placeholder={t('litigation.placeholder.subjectStatus')}
                      isDisabled={disabledRisk}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.courtDisputeOutcomeAssessment')}
                    </label>
                    <TextArea
                      name="courtDisputeOutcomeAssessment"
                      defaultValue={litigation?.courtDisputeOutcomeAssessment}
                      className={`form-control text-area `}
                      placeholder={t(
                        'litigation.placeholder.courtDisputeOutcomeAssessment'
                      )}
                      disabled={disabledRisk}
                    />
                  </Col>
                </Row>
                <Row className="mt-5 field-group-title">
                  <Col className="col-6 col-xl-3">
                    {t('litigation.additionalInformation')}
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col className="col-3 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.category')}
                    </label>
                    <SelectInfinite
                      api="court-category-risks"
                      name="courtCategory"
                      selected={
                        litigation.category !== undefined &&
                        litigation.category.value
                          ? litigation.category
                          : ''
                      }
                      placeholder={t('litigation.placeholder.category')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={disabledRisk}
                    />
                    <label className="label-litigation">
                      {t('litigation.subCategory')}
                    </label>
                    <SelectInfinite
                      api={watchCategory?.value !== undefined ?
                        `/court-subcategory-risks-by-category/${watchCategory?.value}`
                        : `/court-subcategory-risks-by-category/1`}
                      name="subCategory"
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      isDisabled={disableSubCategory}
                      key={`riskSubCategory-${watchCategory?.value || 'empty'}`}
                      defaultValue={
                        litigation.subcategory !== undefined &&
                        litigation.subcategory.value
                          ? litigation.subcategory
                          : ''
                      }
                      placeholder={t('litigation.placeholder.subCategory')}
                      isClearable
                    />
                  {/*  <label className="label-litigation">*/}
                  {/*    {t('litigation.riskCauses')}*/}
                  {/*  </label>*/}
                  {/*  <SelectInfinite*/}
                  {/*    api="risk-causes"*/}
                  {/*    name="riskCauseId"*/}
                  {/*    selected={*/}
                  {/*      litigation.riskCause !== undefined &&*/}
                  {/*      litigation.riskCause.value*/}
                  {/*        ? litigation.riskCause*/}
                  {/*        : ''*/}
                  {/*    }*/}
                  {/*    placeholder={t('litigation.placeholder.riskCauses')}*/}
                  {/*    labelKey={lang === 'mne' ? 'name' : 'nameEn'}*/}
                  {/*    className="select"*/}
                  {/*    isDisabled={disabledRisk}*/}
                  {/*  />*/}
                  {/*  <label className="label-litigation">*/}
                  {/*    {t('litigation.riskSubCause')}*/}
                  {/*  </label>*/}
                  {/*  <SelectInfinite*/}
                  {/*    api={*/}
                  {/*      watchRiskCause?.value !== undefined*/}
                  {/*        ? `/risk-sub-causes?riskCauseId.equals=${watchRiskCause?.value}&active.equals=true`*/}
                  {/*        : `/risk-sub-causes?riskCauseId.equals=1&active.equals=true`*/}
                  {/*    }*/}
                  {/*    name='riskSubCause'*/}
                  {/*    labelKey={lang === 'mne' ? 'name' : 'nameEn'}*/}
                  {/*    placeholder={t('litigation.placeholder.riskSubCause')}*/}
                  {/*    key={watchRiskCause?.value}*/}
                  {/*    className='select'*/}
                  {/*    defaultValue={*/}
                  {/*      litigation.riskSubCause !== undefined &&*/}
                  {/*      litigation.riskSubCause.value*/}
                  {/*        ? litigation.riskSubCause*/}
                  {/*        : ''*/}
                  {/*    }*/}
                  {/*    isDisabled={disableSubCause}*/}
                  {/*  />*/}
                  </Col>
                  <Col className="col-3 col-xl-3">
                    {/*<label className="label-litigation">*/}
                    {/*  {t('litigation.businessLines')}*/}
                    {/*</label>*/}
                    {/*<span className="optional register">*/}
                    {/*  {t('common.optional')}*/}
                    {/*</span>*/}
                    {/*<SelectInfinite*/}
                    {/*  api="business-lines"*/}
                    {/*  name="businessLineId"*/}
                    {/*  selected={*/}
                    {/*    litigation.businessLine !== undefined &&*/}
                    {/*    litigation.businessLine.value*/}
                    {/*      ? litigation.businessLine*/}
                    {/*      : ''*/}
                    {/*  }*/}
                    {/*  placeholder={t('litigation.placeholder.businessLines')}*/}
                    {/*  labelKey={lang === 'mne' ? 'name' : 'nameEn'}*/}
                    {/*  className="select"*/}
                    {/*  isDisabled={disabledRisk}*/}
                    {/*/>*/}
                    <label className="label-litigation">
                      {t('litigation.estimatedGrossLoss')}
                    </label>
                    <InputText
                      type="text"
                      name="estimatedGrossLost"
                      defaultValue={litigation.estimatedGrossLost !== null ? formatNumberInput(formatNumberForDisplay(litigation.estimatedGrossLost)) : ''}
                      className="form-control input-field"
                      placeholder={t(
                        'litigation.placeholder.estimatedGrossLoss'
                      )}
                      disabled={disabledRisk}
                      onChange={(e) => onDecimalNumberInputChange(e,setValue,"estimatedGrossLost")}
                      onPaste={(e) => handlePasteAndValidate(e, setValue, trigger, 'estimatedGrossLost')}
                    />
                    <label className="label-litigation">
                      {t('litigation.typeGainLoss')}
                    </label>
                    <span className="optional register">
                      {t('common.optional')}
                    </span>
                    <SelectInfinite
                      api="type-gain-losses"
                      name="typeGainLossId"
                      selected={
                        litigation.typeGainLoss !== undefined &&
                        litigation.typeGainLoss.value
                          ? litigation.typeGainLoss
                          : ''
                      }
                      placeholder={t('litigation.placeholder.typeGainLoss')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={disabledRisk}
                    />
                    {/*<label className="label-litigation">*/}
                    {/*  {t('litigation.metodologies')}*/}
                    {/*</label>*/}
                    {/*<SelectInfinite*/}
                    {/*  api="methodologies"*/}
                    {/*  name="methodologyId"*/}
                    {/*  selected={*/}
                    {/*    litigation.methodology !== undefined &&*/}
                    {/*    litigation.methodology.value*/}
                    {/*      ? litigation.methodology*/}
                    {/*      : ''*/}
                    {/*  }*/}
                    {/*  placeholder={t('litigation.placeholder.metodologies')}*/}
                    {/*  labelKey={lang === 'mne' ? 'name' : 'nameEn'}*/}
                    {/*  className="select"*/}
                    {/*  isDisabled={disabledRisk}*/}
                    {/*/>*/}

                  </Col>
                  <Col className="col-3 col-xl-3">
                    <label className="label-litigation">
                      {t('litigation.department')}
                    </label>
                    <SelectList
                      name="departmentStakeholderId"
                      selected={
                        litigation.departmentStakeholder !== undefined &&
                        litigation.departmentStakeholder.value
                          ? litigation.departmentStakeholder
                          : ''
                      }
                      options={departmentOptions}
                      className="select"
                      placeholder={t('litigation.placeholder.department')}
                      isDisabled={disabledRisk}
                    />
                    {userDepartment?.length === 1 ? (
                      <>
                        <label className="label-potential-risk">
                          {t('litigation.responsibleUser')}
                        </label>
                        <SelectInfinite
                          api="users"
                          name="userResponsibleId"
                          labelKey="firstName"
                          placeholder={t('litigation.placeholder.responsibleUser')}
                          className="select"
                          isDisabled={true}
                          defaultValue={{
                            value:
                              userDepartment[0]?.id !== undefined
                                ? userDepartment[0]?.userResponsibleId
                                : '',
                            label:
                              userDepartment[0]?.id !== undefined
                                ? userDepartment[0]?.userResponsibleFirstName +
                                ' ' +
                                userDepartment[0]?.userResponsibleLastName
                                : '',
                          }}
                        />
                      </>
                    ) : (
                      <>
                        <label className="label-potential-risk">
                          {t('litigation.responsibleUser')}
                        </label>
                        <SelectInfinite
                          api="users"
                          name="userResponsibleId"
                          labelKey="firstName"
                          placeholder={t('litigation.placeholder.responsibleUser')}
                          className="select"
                          isDisabled={true}
                        />
                      </>
                    )}
                  </Col>
                  <Col className="col-3 col-xl-3">
                    {/*<label className="label-litigation">*/}
                    {/*  {t('litigation.process')}*/}
                    {/*</label>*/}
                    {/*<SelectInfinite*/}
                    {/*  api="processes"*/}
                    {/*  name="process"*/}
                    {/*  defaultValue={*/}
                    {/*    litigation.process !== undefined &&*/}
                    {/*    litigation.process.value*/}
                    {/*      ? litigation.process*/}
                    {/*      : ''*/}
                    {/*  }*/}
                    {/*  placeholder={t('litigation.placeholder.process')}*/}
                    {/*  labelKey={lang === 'mne' ? 'name' : 'nameEn'}*/}
                    {/*  className="select"*/}
                    {/*  isDisabled={disabledRisk}*/}
                    {/*/>*/}
                    {/*<label className="label-litigation">*/}
                    {/*  {t('litigation.subprocess')}*/}
                    {/*</label>*/}
                    {/*<SelectInfinite*/}
                    {/*  api={*/}
                    {/*    watchProcess?.value !== undefined*/}
                    {/*      ? `/subprocesses?processId.equals=${watchProcess?.value}&active.equals=true`*/}
                    {/*      : `/subprocesses?processId.equals=1&active.equals=true`*/}
                    {/*  }*/}
                    {/*  name="subprocessId"*/}
                    {/*  labelKey={lang === 'mne' ? 'name' : 'nameEn'}*/}
                    {/*  placeholder={t('litigation.placeholder.subprocess')}*/}
                    {/*  key={watchProcess?.value}*/}
                    {/*  className="select"*/}
                    {/*  defaultValue={*/}
                    {/*    litigation?.subprocess !== undefined*/}
                    {/*      ? litigation?.subprocess*/}
                    {/*      : ''*/}
                    {/*  }*/}
                    {/*  isDisabled={disableSubprocess}*/}
                    {/*/>*/}
                    <label className="label-litigation" htmlFor={'attachFile'}>
                      {t('litigation.attachFiles')}
                    </label>
                    <FileUploadSection
                      disabled={disabledRisk}
                      allowedFileTypes={allowedFileTypes}
                      fetchedFiles={litigation.files}
                      onDeleteFetchedFile={clearFetchedFile}
                      onNewFilesChange={(newFiles) => setFiles(newFiles)}
                      onFileDownload={getRiskFile}
                    />
                    <label className="label-litigation">
                      {t('litigation.additionalComment')}
                    </label>
                    <span className="optional register">
                  {t('common.optional')}
                </span>
                    <TextArea
                      name="comment"
                      defaultValue={litigation.comment}
                      className={`form-control text-area `}
                      placeholder={t(
                        'litigation.placeholder.additionalComment'
                      )}
                      disabled={disabledRisk}
                    />
                  </Col>
                </Row>
                                <Row className="mt-5 field-group-title">
                                    <Col className="col-6 col-xl-3">
                                        {t('litigation.systemAddedInformation')}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="col-6 col-xl-3">
                                        <label className="label-litigation">
                                            {t('litigation.id')}
                                        </label>
                                        <InputText
                                            type="text"
                                            name="id"
                                            defaultValue={litigation.riskId}
                                            className="form-control input-field"
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col className="col-6 col-xl-3 d-flex flex-column">
                                        <label className="label-litigation">
                                            {t('litigation.dateCreated')}
                                        </label>
                                        <InputDate
                                            name="dateCreated"
                                            defaultValue={new Date(litigation.riskDateCreated)}
                                            style={{height: '45px!important'}}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col className="col-6 col-xl-3">
                                        <label className="label-litigation">
                                            {t('litigation.status')}
                                        </label>
                                        <InputText
                                            type="text"
                                            name="riskStatus"
                                            defaultValue={litigation.riskStatus}
                                            className="form-control input-field"
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col className="col-6 col-xl-3">
                                        <label className="label-litigation">
                                            {t('litigation.department')}
                                        </label>
                                        <InputText
                                            type="text"
                                            name="departmentSource"
                                            defaultValue={litigation.departmentSource}
                                            className="form-control input-field"
                                            disabled={true}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="col-6 col-xl-3">
                                        <label className="label-litigation">
                                            {t('litigation.userInChargeRisk')}
                                        </label>
                                        <InputText
                                            type="text"
                                            name="userInChargeRisk"
                                            defaultValue={litigation.userInChargeRisk}
                                            className="form-control input-field"
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col className="col-6 col-xl-3 mb-5">
                                        <label className="label-litigation">
                                            {t('litigation.responsibleUserRisk')}
                                        </label>
                                        <InputText
                                            type="text"
                                            name="responsibleUserRisk"
                                            defaultValue={litigation.responsibleUserRisk}
                                            className="form-control input-field"
                                            disabled={true}
                                        />
                                    </Col>
                                </Row>
                <Row>
                  <Col className="col-3 col-xl-3 pb-5">
                    <label className="label-litigation">
                      {t('codebook.addExpense')}
                    </label>
                    <span className="optional register">
                       {t('common.optional')}
                    </span>
                    <p className={'file-input'} style={{marginBottom: '-8px',
                      backgroundColor: disabledRisk ? 'hsl(0, 0%, 95%)' : '#d3e1f5'
                    }} onClick={() => {
                      if(!disabledRisk) {
                        setIsEdit(false)
                        setLossModalOpen(true)
                      }
                    }}></p>
                    <LossModal
                      open={lossModalOpen}
                      setLossData={setLossData}
                      lossData={lossData}
                      id={currentID}
                      isEdit={isEdit}
                      riskId={defaultData?.id}
                      isOpen={(e) => setLossModalOpen(e)}
                    />
                  </Col>
                </Row>
                <Row>
                  {lossData?.map((item,index) => (
                    <>
                      <Col className="col-2">
                        <label className="label-litigation">
                          {t('codebook.codebook')}
                        </label>
                        <SelectInfinite
                          api="/loss-reasons"
                          name={`lossData.${index}.account`}
                          placeholder={t('incurred-risk.placeholder.category')}
                          labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                          className="select"
                          isDisabled={true}
                          defaultValue={item?.lossReason}
                        />
                      </Col>
                      <Col className="col-2" style={{marginRight: '5px'}}>
                        <label className="label-litigation">
                          {t('codebook.lossDate')}
                        </label>
                        <InputDate
                          name="lossDate"
                          selected={new Date(item?.lossDate)}
                          placeholder={t('codebook.lossDatePlaceholder')}
                          style={{height: '65px!important'}}
                          forceSelected={true}
                          disabled={true}
                          isClearable={false}
                        />
                      </Col>
                      <Col className="col-2" style={{marginRight: '5px'}}>
                        <label className="label-incurred mt-2">
                          {t('codebook.descriptionLoss')}
                        </label>
                        <TextArea
                          name="descriptionLoss"
                          disabled={true}
                          key={`description-${item.id ?? item.tempId}-${item.description}`}
                          value={item?.description}
                          placeholder={t('codebook.descriptionLossPlaceholder')}
                        />
                      </Col>
                      <Col className="col-2" style={{marginRight: '5px'}}>
                        <label className="label-litigation">
                          {t('codebook.loss')}
                        </label>
                        <InputText
                          type="text"
                          name="netLoss"
                          className="form-control input-field"
                          placeholder={t('incurred-risk.placeholder.title')}
                          disabled={true}
                          value={item?.netLoss ? formatNumberInput(formatNumberForDisplay(item?.netLoss)) : ''}
                        />
                      </Col>
                      {!disabledRisk &&  <div style={{marginTop: '20px'}}>
                        <img style={{marginTop: '30px',marginLeft: '5px',cursor: 'pointer'}} onClick={() => {
                        setLossModalOpen(true);
                        setCurrentID(item.id ?? item.tempId);
                        setIsEdit(true);
                      }} src={editImage} alt={'edit'}/>
                        <img style={{marginTop: '30px',marginLeft: '5px',cursor: 'pointer'}} onClick={() => deleteConto(item?.id ?? item?.tempId)} src={deleteImage} alt={'delete'}/>
                      </div>}
                    </>
                  ))}
                </Row>
                <Row className="pb-5 pt-2">
                  {lossData?.length > 0 &&
                    <>
                    <Col className="col-2" style={{marginRight: '5px'}}>
                      <label className="label-litigation">
                        {t('litigation.grossLoss')}
                      </label>
                      <InputText
                        type="text"
                        name="grossLoss"
                        className="form-control input-field"
                        placeholder={t('litigation.placeholder.placeholder.grossLoss')}
                        disabled={true}
                        value={formatNumber(sum)}
                      />
                    </Col>
                    <Col className="col-2" style={{marginRight: '5px'}}>
                      <label className="label-litigation">
                        {t('litigation.lossChargedInsurance')}
                      </label>
                      <InputText
                        type="text"
                        name="lossChargedInsurance"
                        onChange={handleChange}
                        defaultValue={formatNumberInput(formatNumberForDisplay(defaultData?.lossChargedInsurance))}
                        className="form-control input-field"
                        placeholder={t('litigation.placeholder.placeholder.lossChargedInsurance')}
                        disabled={disabledRisk}
                      />
                    </Col>
                    <Col className="col-2" style={{marginRight: '5px'}}>
                      <label className="label-litigation">
                        {t('litigation.lossChargedOther')}
                      </label>
                      <InputText
                        type="text"
                        name="lossChargedOther"
                        onChange={handleChange}
                        defaultValue={formatNumberInput(formatNumberForDisplay(defaultData?.lossChargedOther))}
                        className="form-control input-field"
                        placeholder={t('litigation.placeholder.placeholder.lossChargedOther')}
                        disabled={disabledRisk}
                      />
                    </Col>
                    <Col className="col-2" style={{marginRight: '5px'}}>
                      <label className="label-litigation">
                        {t('litigation.netLossNumber')}
                      </label>
                      <InputText
                        type="text"
                        name="netLossNumber"
                        className="form-control input-field"
                        placeholder={t('litigation.placeholder.placeholder.lossChargedOther')}
                        disabled={true}
                        defaultValue={defaultData?.netLoss}
                        value={formatNumber(netLossNumberValue)}
                      />
                    </Col>
                    </>}
                </Row>
                                <div>
                                    {!disabledRisk ? (
                                        <Row className="form-footer w-100" key={disabledRisk}>
                                            <button
                                                className="secondary-btn"
                                                type="reset"
                                                onClick={handleCancel}
                                            >
                                                {t('buttons.cancel')}
                                            </button>
                                            <button className="primary-btn">
                                                {t('buttons.save')}
                                            </button>
                                        </Row>
                                    ) : null}
                                </div>
                            </form>
                        </FormProvider>
                    </div>
                </>
            )}
        </>
    );
};

export default Litigation;
